import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { PricingOfferCta } from './pricing-offer-cta.model';

export const PRICING_OFFER_SCHEMA = Object.freeze({
  IMAGE: '',
  HEADER: '',
  BODY: '',
  CTAS: List<PricingOfferCta>([]),
});

const RECORD = generateSchema(PRICING_OFFER_SCHEMA);
const KEYS: any = generateKeys(PRICING_OFFER_SCHEMA);

export class PricingOffer extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});
    super(props);

    return setInModel(this, [
      {
        key: KEYS.CTAS,
        value: props.get(KEYS.CTAS)
          ? this.ctas.map((params) => new PricingOfferCta(params))
          : [],
      },
    ]) as PricingOffer;
  }

  get image(): string {
    return this.get(KEYS.IMAGE);
  }

  get header(): string {
    return this.get(KEYS.HEADER);
  }

  get body(): string {
    return this.get(KEYS.BODY);
  }

  get ctas(): List<PricingOfferCta> {
    return this.get(KEYS.CTAS);
  }
}
